export default __webpack_public_path__ + "static/media/client2.fe6e9f0f.png";